import { AuthService } from './../../services/auth.service';
import { Office } from '../../models/office.model';
import { Broker } from '../../models/broker.model';
import { PropertiesService } from '../../services/properties.service';
import { Property } from '../../models/property.model';
import { ErrorResponse } from '../../models/error.model';
import { PageEvent } from '@angular/material/paginator';
import { UtilsService } from '../../services/utils.service';
import { PaginatorStatus, DataTableColumn, SortConfiguration } from '../generics/data-table/data-table.component';
import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { CustomTableFilter } from '../generics/table-filter/table-filter.component';
import { UserType } from '../../models/user.model';

@Component({
  selector: 'app-properties',
  templateUrl: './properties.component.html',
  styleUrls: ['./properties.component.scss']
})
export class PropertiesComponent implements OnInit {

    @ViewChild('buttonsColumnTemplate', { static: true })
    buttonsColumnTeplate: TemplateRef<any>;

    paginatorStatus: PaginatorStatus = {
        itemsPerPage: 50,
        page: 0,
        totalElementCount: 0
    };

    columns: DataTableColumn[] = [
        { name: 'Código', prop: 'codigo', sortable: true },
        { name: 'Fecha', prop: 'fechaCreacion', sortable: true, type: 'datetime' },
        { name: 'Calle', prop: 'direccion.calle', sortable: true },
        { name: 'Número', prop: 'direccion.numero', sortable: true },
        { name: 'Piso', prop: 'direccion.piso', sortable: true },
        { name: 'Departamento', prop: 'direccion.departamento', sortable: true },
        { name: 'Agente', prop: 'agente', parseValue: (agente: Broker) => `${agente.nombre ?? ''} ${agente.apellido ?? ''}` },
        { name: 'Oficina', prop: 'oficina', parseValue: (oficina: Office) => `${oficina.sucursal} - ${oficina.nombre}` },
        { name: 'Alquiler', prop: 'alquiler', sortable: true, type: 'money' },
        { name: 'Expensas', prop: 'expensas', sortable: true, type: 'money' },
        { name: '', width: '140px' }
    ];

    sortConfiguration?: SortConfiguration;

    properties: Property[];

    filters: CustomTableFilter[] = [
        { key: 'fecha-desde', description: 'Fecha desde', type: 'DATE' },
        { key: 'fecha-hasta', description: 'Fecha hasta', type: 'DATE' },
        { key: 'codigo', description: 'Código', type: 'NUMBER' },
        { key: 'propietario-nombre', description: 'Nombre del propietario', type: 'STRING' },
        { key: 'propietario-apellido', description: 'Apellido del propietario', type: 'STRING' },
        { key: 'propietario-dni', description: 'DNI del propietario', type: 'STRING' },
        { key: 'propietario-razonSocial', description: 'Razón social del propietario', type: 'STRING' },
        { key: 'propietario-cuit', description: 'CUIT del propietario', type: 'STRING' },
        { key: 'direccion', description: 'Dirección', type: 'STRING' },
    ];
    filterValues: any = {};

    userType?: UserType;

    constructor(
        private propertyService: PropertiesService,
        private authService: AuthService,
        private utilsService: UtilsService
    ) {}

    ngOnInit(): void {
        this.columns.find(col => col.name === '').template = this.buttonsColumnTeplate;
        this.getProperties();
        this.userType = this.authService.getUser()?.tipo;
        if (this.userType !== 'AGENTE') {
            this.columns[this.columns.length - 1].width = '70px';
        }
    }

    getProperties() {
        this.propertyService.getProperties(this.paginatorStatus.page, this.paginatorStatus.itemsPerPage, this.sortConfiguration ? [this.sortConfiguration] : [], this.filterValues)
        .subscribe(response => {
            this.paginatorStatus.totalElementCount = parseInt(response.headers.get('pagination-total-count') ?? '0', 10);
            this.properties = response.body;
        }, (error: ErrorResponse) => this.utilsService.alert('Error al obtener propiedades', error.error?.descripcion));
    }

    updateProperties(event: PageEvent) {
        this.paginatorStatus.itemsPerPage = event.pageSize;
        this.paginatorStatus.page = event.pageIndex;
        this.getProperties();
    }

    updateSort(event: SortConfiguration) {
        this.sortConfiguration = event;
        this.getProperties();
    }

    deleteProperty(property: Property) {
        const dialog = this.utilsService.confirm('¿Está seguro?', 'Esta acción no se puede deshacer.');
        dialog.afterClosed().subscribe(result => {
            if (result) {
                this.propertyService.deleteProperty(property.id).subscribe(_ => {
                    this.utilsService.alert('Propiedad borrada correctamente', `Se ha eliminado la propiedad ${property.direccion.calle} ${property.direccion.numero} de la plataforma.`);
                    this.getProperties();
                }, (error: ErrorResponse) => this.utilsService.alert('Error al borrar la propiedad', error.error?.descripcion));
            }
        });
    }

    setFilterValues(values: any) {
        this.filterValues = values;
        this.getProperties();
    }
}
